// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"222":"4a952f5fbb4cb6bcd0a2","5539":"d7bb2dfa9524b3a98fba"}[chunkId] + ".js";
};